module.exports = __webpack_public_path__ + "static/media/thumbnail.d377b25d.jpg";